import { createAsyncThunk } from "@reduxjs/toolkit";

// import authApi from "api/authApi";
import authService from "services/auth/authService";

export const login = createAsyncThunk(
    "auth/login",
    async (credentials, thunkAPI) => {
        try {
            const response = await authService.login(credentials);

            return response;
        } catch (error) {
            /* return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                "Login failed."
            );*/
            const message =
                error.status === 500
                    ? "Login failed. Invalid username or password."
                    : error.response?.data?.message ||
                      error.response?.data?.title ||
                      error.message ||
                      "Login failed. Invalid username or password.";

            return thunkAPI.rejectWithValue(message);
        }
    }
);
